/* PNM Blog Archive — shared behaviour: scroll-reveal, view toggle, tabs, sort, saves, live search, load-more.
   Works across split sections by querying the document, not a single root. */
(function(){
  if (!document.querySelector('.pm-archive-root')) return;

  var BATCH_SIZE = 12;

  // Scroll reveal (any root)
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){ if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }});
    }, { threshold: .12 });
    document.querySelectorAll('.pm-archive-root [data-reveal]').forEach(function(el){ io.observe(el); });
  } else {
    document.querySelectorAll('.pm-archive-root [data-reveal]').forEach(function(el){ el.classList.add('in'); });
  }

  function getCards(){ return document.querySelectorAll('.pm-archive-root .acard'); }
  function getCountEls(){ return document.querySelectorAll('.pm-archive-root .main-bar .count b'); }

  function visibleCardCount(){
    var n = 0;
    getCards().forEach(function(c){
      var hiddenInline = c.style.display === 'none';
      var beyond = c.classList.contains('is-beyond-limit') && !document.body.classList.contains('pm-archive-show-all');
      if (!hiddenInline && !beyond) n++;
    });
    return n;
  }

  var loadMoreBtn = document.querySelector('.pm-archive-root .load-more');
  function refreshLoadMore(){
    if (!loadMoreBtn) return;
    var anyHidden = !!document.querySelector('.pm-archive-root .acard.is-beyond-limit');
    var showAll = document.body.classList.contains('pm-archive-show-all');
    loadMoreBtn.hidden = showAll || !anyHidden;
  }
  if (loadMoreBtn){
    loadMoreBtn.addEventListener('click', function(){
      var hidden = document.querySelectorAll('.pm-archive-root .acard.is-beyond-limit');
      var n = Math.min(BATCH_SIZE, hidden.length);
      for (var i = 0; i < n; i++) hidden[i].classList.remove('is-beyond-limit');
      refreshLoadMore();
      // Update toolbar / pager counts
      var count = visibleCardCount();
      var total = getCards().length;
      var els = getCountEls();
      if (els.length >= 2){ els[0].textContent = '1–' + count; els[1].textContent = total + ' articles'; }
      var pc = document.getElementById('pager-count');
      var pi = document.getElementById('pager-info');
      if (pc) pc.textContent = count;
      if (pi){
        pi.innerHTML = count >= total
          ? 'Showing all <b id="pager-count">' + total + '</b> articles — that’s everything we’ve published.'
          : 'Showing <b id="pager-count">' + count + '</b> of ' + total + ' articles.';
      }
    });
  }
  refreshLoadMore();

  // View toggle
  document.querySelectorAll('.pm-archive-root .view-toggle button').forEach(function(b){
    b.addEventListener('click', function(){
      document.querySelectorAll('.pm-archive-root .view-toggle button').forEach(function(x){ x.classList.remove('on'); });
      b.classList.add('on');
      document.body.classList.toggle('pm-archive-list', b.dataset.view === 'list');
    });
  });

  // Category tabs — selecting any non-"all" tab puts us in "show all matches" mode
  document.querySelectorAll('.pm-archive-root .cat-tab').forEach(function(t){
    t.addEventListener('click', function(){
      document.querySelectorAll('.pm-archive-root .cat-tab').forEach(function(x){ x.classList.remove('on'); });
      t.classList.add('on');
      var filter = t.dataset.blogFilter || '__all__';
      var searchActive = !!(document.getElementById('pm-archive-search') && document.getElementById('pm-archive-search').value.trim());
      // A filter or active search bypasses the load-more limit
      if (filter !== '__all__' || searchActive){
        document.body.classList.add('pm-archive-show-all');
      } else {
        document.body.classList.remove('pm-archive-show-all');
      }
      var visible = 0;
      getCards().forEach(function(card){
        var show = filter === '__all__' || card.dataset.blog === filter;
        card.style.display = show ? '' : 'none';
        if (show) visible++;
      });
      var els = getCountEls();
      if (els.length >= 2) { els[0].textContent = '1–' + visible; els[1].textContent = visible + ' articles'; }
      var pc = document.getElementById('pager-count');
      var pi = document.getElementById('pager-info');
      if (pc) pc.textContent = visible;
      if (pi) pi.innerHTML = filter === '__all__'
        ? 'Showing all <b id="pager-count">' + visible + '</b> articles — that’s everything we’ve published.'
        : 'Showing <b id="pager-count">' + visible + '</b> articles in this category.';
      refreshLoadMore();
    });
  });

  // Sort — reorder DOM and re-mark .is-beyond-limit on new order (preserves loadedCount)
  var sortSel = document.getElementById('pm-archive-sort');
  if (sortSel) {
    sortSel.addEventListener('change', function(){
      var grid = document.getElementById('results');
      if (!grid) return;
      var cards = Array.prototype.slice.call(grid.querySelectorAll('.acard'));
      var loadedCount = cards.filter(function(c){ return !c.classList.contains('is-beyond-limit'); }).length || BATCH_SIZE;
      cards.sort(function(a, b){
        if (sortSel.value === 'oldest') return (a.dataset.published||'').localeCompare(b.dataset.published||'');
        if (sortSel.value === 'alpha')  return (a.dataset.title||'').localeCompare(b.dataset.title||'');
        return (b.dataset.published||'').localeCompare(a.dataset.published||'');
      });
      cards.forEach(function(c, idx){
        grid.appendChild(c);
        if (idx < loadedCount) c.classList.remove('is-beyond-limit');
        else c.classList.add('is-beyond-limit');
      });
      refreshLoadMore();
    });
  }

  // Saves (localStorage['pm:articles:saved'] — shared key with rest of site)
  var ART_KEY = 'pm:articles:saved';
  function readList(){ try { return JSON.parse(localStorage.getItem(ART_KEY) || '[]'); } catch(e) { return []; } }
  function writeList(a){ try { localStorage.setItem(ART_KEY, JSON.stringify(a)); } catch(e) {} }
  function findIdx(list, h){ for (var i=0; i<list.length; i++) { if (list[i] && list[i].handle === h) return i; } return -1; }
  function slug(s){ return String(s||'').toLowerCase().trim().replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,''); }
  function pulse(el){ el.classList.remove('is-pulse'); void el.offsetWidth; el.classList.add('is-pulse'); }

  function paintSaves(){
    var list = readList();
    getCards().forEach(function(card){
      var btn = card.querySelector('.save[data-save="article"]');
      if (!btn) return;
      var handle = card.dataset.handle || slug(card.dataset.title || '');
      btn.dataset.handle = handle;
      btn.setAttribute('aria-pressed', findIdx(list, handle) > -1 ? 'true' : 'false');
    });
  }
  paintSaves();

  getCards().forEach(function(card){
    var btn = card.querySelector('.save[data-save="article"]');
    if (!btn) return;
    btn.addEventListener('click', function(e){
      e.preventDefault(); e.stopPropagation();
      var handle = btn.dataset.handle;
      var list = readList();
      var i = findIdx(list, handle);
      var saved;
      if (i > -1) { list.splice(i, 1); saved = false; }
      else {
        list.unshift({
          handle: handle,
          title: (card.dataset.title || '').trim(),
          url: card.dataset.url || '',
          image: card.dataset.image || '',
          excerpt: card.dataset.excerpt || '',
          author: card.dataset.author || '',
          savedAt: new Date().toISOString()
        });
        if (list.length > 50) list.length = 50;
        saved = true;
      }
      writeList(list);
      btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
      if (saved) pulse(btn);
      try { if (window._learnq) window._learnq.push(['track', saved ? 'Saved Article' : 'Unsaved Article', { handle: handle, source: 'blog-archive' }]); } catch(e) {}
      document.dispatchEvent(new CustomEvent('pm:articles:saved-changed', { detail: { handle: handle, saved: saved, count: list.length }}));
    });
  });
  window.addEventListener('storage', function(e){ if (e.key === ART_KEY) paintSaves(); });

  // Live search — any non-empty query bypasses the load-more limit
  var input = document.getElementById('pm-archive-search');
  var goBtn = document.querySelector('.pm-archive-root .search-shell .go');

  function applyFilter(query){
    var q = (query || '').toLowerCase().trim();
    var activeTab = document.querySelector('.pm-archive-root .cat-tab.on');
    var catActive = activeTab && activeTab.dataset.blogFilter && activeTab.dataset.blogFilter !== '__all__';
    if (q || catActive){
      document.body.classList.add('pm-archive-show-all');
    } else {
      document.body.classList.remove('pm-archive-show-all');
    }
    var visible = 0;
    var cards = getCards();
    cards.forEach(function(card){
      if (!q) { card.style.display = ''; visible++; return; }
      var hay = (card.textContent + ' ' + (card.dataset.tags||'') + ' ' + (card.dataset.author||'') + ' ' + (card.dataset.title||'')).toLowerCase();
      var match = hay.indexOf(q) > -1;
      card.style.display = match ? '' : 'none';
      if (match) visible++;
    });
    var els = getCountEls();
    if (els.length >= 2) {
      if (q) { els[0].textContent = visible; els[1].textContent = visible + (visible === 1 ? ' result' : ' results'); }
      else { els[0].textContent = '1–' + visibleCardCount(); els[1].textContent = cards.length + ' articles'; }
    }
    refreshLoadMore();
  }

  if (input) {
    input.addEventListener('input', function(){ applyFilter(input.value); });
    input.addEventListener('keypress', function(e){ if (e.key === 'Enter') applyFilter(input.value); });
  }
  if (goBtn) { goBtn.addEventListener('click', function(e){ e.preventDefault(); applyFilter(input ? input.value : ''); }); }
  document.querySelectorAll('.pm-archive-root [data-suggest]').forEach(function(a){
    a.addEventListener('click', function(e){
      e.preventDefault();
      if (!input) return;
      input.value = a.textContent.trim();
      applyFilter(input.value);
      input.focus();
      var grid = document.getElementById('pm-archive-results');
      if (grid) grid.scrollIntoView({ behavior:'smooth', block:'start' });
    });
  });
})();
